import { handleActions } from 'redux-actions'
import client from 'common/util/http'

export const getMapUrl = (latitude, longitude, zoom, scale, width, height, maptype, paths, format, skip_encoding) => {
  return dispatch => {
    return client.post('map_url', {
      data: {
        latitude,
        longitude,
        zoom,
        scale,
        width,
        height,
        maptype,
        paths,
        format,
        skip_encoding: skip_encoding ? skip_encoding : false
      }
    })
      .then(response => Promise.resolve(response))
      .catch(error => Promise.reject(error))
  }
}

export default handleActions({
}, {})